import logger from '@/modules/Logger';
import { buildJoinMeta, joinPrefix } from '@/modules/webrtc/joinLogUtils';

export default {
  async publishTracks() {
    this.setStreamConfig();

    const trackCount = this.localTracks.length;
    logger.info(`${joinPrefix('Agora')} Publishing ${trackCount} track(s) to channel`, buildJoinMeta({ provider: 'agora', lessonId: this.lessonId }));

    try {
      // unpublish existing stream before publish new one
      await this.unpublish();

      // Publish local audio/video tracks to the channel.
      if (this.localTracks.length) {
        await this.rtc.publish(this.localTracks);
      }

      logger.info(`${joinPrefix('Agora')} Tracks published to channel successfully`, buildJoinMeta({ provider: 'agora', lessonId: this.lessonId }));
      logger.debug('[Agora] Success on publishing local tracks', { operation: 'webrtc:publish' });

    } catch (err) {
      logger.error('[Agora] Error publishing stream', { operation: 'webrtc:publish', error: err,event_type:51,lesson_id:this.lessonId });
    }

    const localMediaStream = new MediaStream();
    this.localTracks.forEach(track => {
      localMediaStream.addTrack(track._mediaStreamTrack);
    });
    // retain the usability of stream instead of seperate audio/videotracks
    return localMediaStream;
  }
}
